module.exports = __webpack_public_path__ + "static/armor_of_invulnerability-5b6c22e771e695528ee6492ee541daf8.jpeg";